import gql from 'graphql-tag';

export default gql`
  mutation adminRestoreSchool($schoolId: ID!) {
    adminRestoreSchool(schoolId: $schoolId) {
      id
    }
  }
`;
